import React from "react";
import Button from "devextreme-react/button";
import "./SimpleButton.scss";

const SimpleButton = props => {
    const propsClasses = props.className ? ` ${props.className}` : "";
    return (
        <div className={`simplebutton${propsClasses}`}>
            <Button {...props} />
        </div>
    );
};
export default SimpleButton;
